var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _circle, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgStakeNEarn = function SvgStakeNEarn(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.353 33.198c0 .147 0 .294-.049.393 0 .098-.049.245-.049.343 0 .147-.049.246-.049.393a.912.912 0 0 1-.097.343c-.05.148-.05.246-.098.393-.05.098-.05.246-.098.344-.049.147-.098.245-.147.392-.049.099-.098.246-.146.344-.05.147-.098.294-.196.393-.05.098-.098.245-.147.343-.049.148-.147.295-.196.393a2.83 2.83 0 0 1-.195.344c-.098.147-.196.343-.294.49-.049.099-.146.197-.195.295-.098.196-.245.343-.392.54-.049.098-.097.147-.146.245-.196.295-.44.54-.685.835l-.196.196-.587.59-.293.294c-.147.098-.245.245-.392.343-.097.098-.244.197-.39.295-.148.098-.294.245-.441.343-.147.099-.245.197-.391.295-.147.098-.294.196-.44.343l-.44.295c-.148.098-.343.196-.49.294-.196.148-.391.246-.636.393-.391.245-.831.442-1.223.687-.097.05-.244.147-.39.197-.343.147-.637.343-.98.49-.097.05-.244.099-.342.148-.44.196-.88.392-1.32.54-.098.049-.147.049-.245.098-.391.147-.782.294-1.174.392-.146.05-.342.099-.489.148-.195.049-.44.147-.636.196-.195.05-.391.098-.538.147a3.59 3.59 0 0 0-.684.197l-.587.147c-.245.049-.44.098-.685.147l-.587.148c-.245.049-.49.098-.685.147-.196.049-.342.049-.538.098a16.24 16.24 0 0 1-1.516.245c-.098 0-.147 0-.245.05l-1.32.147c-.147 0-.343.049-.539.049-.293.049-.587.049-.88.049-.196 0-.342.049-.538.049-.294 0-.587.049-.93.049h-3.13c-.244 0-.538 0-.783-.05h-.538c-.293 0-.537-.048-.831-.048-.147 0-.342 0-.49-.05-.341-.048-.684-.048-1.026-.097-.098 0-.147 0-.245-.05-.44-.049-.88-.098-1.272-.147-.048 0-.146 0-.195-.049-.343-.049-.734-.098-1.076-.196-.147-.05-.294-.05-.44-.098-.294-.05-.539-.099-.832-.148-.147-.049-.294-.049-.44-.098-.294-.049-.587-.147-.88-.196-.148-.05-.343-.098-.49-.147-.293-.05-.538-.148-.831-.197l-.44-.147c-.44-.147-.832-.245-1.272-.393-.098-.049-.147-.049-.245-.049-.49-.147-.978-.343-1.418-.54-.196-.098-.392-.147-.587-.245-.147-.05-.294-.098-.44-.196-.196-.099-.44-.197-.636-.295-.147-.049-.294-.098-.392-.196-.244-.099-.44-.246-.684-.344-.098-.049-.245-.098-.343-.147-.342-.197-.636-.344-.978-.54C6.14 40.659 3.5 36.584 3.5 32.56v6.38c0 4.075 2.641 8.1 7.924 11.192.293.197.636.344.978.54.098.05.245.098.343.147.244.099.44.246.684.344.147.05.294.147.392.196.195.099.39.197.636.295.146.049.293.147.44.196.146.05.293.098.44.197.049 0 .098.049.147.049.489.196.929.343 1.418.54a.44.44 0 0 0 .245.049c.44.147.831.294 1.272.392.048 0 .146.05.195.05.098 0 .147.048.245.048.293.099.538.148.831.197.147.049.343.098.49.147.293.05.586.147.88.196.098.05.244.05.342.099h.098c.294.049.538.098.831.147.147.049.294.049.44.098.343.05.734.098 1.077.196.049 0 .146 0 .196.05.44.048.88.098 1.271.147.098 0 .196 0 .245.049.342.049.684.049 1.027.098.147 0 .293 0 .44.049.294 0 .538.05.832.05h.538c.244 0 .538 0 .782.048h3.131c.293 0 .587-.049.93-.049.195 0 .341-.049.537-.049.294 0 .587-.049.88-.049.098 0 .196 0 .294-.05.049 0 .147 0 .196-.048l1.32-.148c.098 0 .147 0 .245-.049a16.23 16.23 0 0 0 1.516-.245h.147c.147 0 .245-.05.391-.098.245-.05.49-.098.685-.147l.587-.148c.245-.049.44-.098.685-.147l.587-.147c.244-.05.44-.098.684-.197.196-.049.392-.098.539-.147.195-.049.44-.147.635-.196.098-.05.196-.05.294-.098.049 0 .147-.05.196-.05.39-.147.782-.245 1.173-.392.098-.05.147-.05.245-.098.44-.197.88-.344 1.32-.54.099-.05.245-.098.343-.147.343-.148.685-.295.978-.491.147-.05.245-.098.392-.197.44-.196.831-.441 1.222-.687.098-.049.245-.147.343-.196.098-.05.196-.147.293-.197.147-.098.343-.196.49-.294l.44-.294c.146-.099.293-.197.44-.344.147-.098.293-.196.391-.295.147-.098.294-.196.44-.343.147-.098.245-.197.392-.295.146-.098.244-.245.391-.343l.147-.148.147-.147.587-.589.195-.196c.245-.246.49-.54.685-.835l.049-.049c.049-.049.098-.147.147-.196.146-.196.244-.344.39-.54.05-.098.148-.196.197-.295.097-.147.195-.294.293-.49.049-.05.049-.099.098-.148.049-.049.049-.147.098-.196.049-.147.146-.245.195-.393.05-.098.098-.245.147-.343.049-.147.098-.295.196-.393 0-.049.049-.098.098-.196 0-.05.048-.098.048-.147.05-.148.098-.246.147-.393.05-.098.05-.246.098-.344.049-.147.049-.245.098-.392 0-.05.049-.148.049-.197v-.147c.049-.147.049-.245.049-.393 0-.098.049-.245.049-.343 0-.148 0-.295.048-.393V32.757c.147.146.147.294.147.44Z",
    fill: "url(#paint0_linear_264_13411)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_264_13411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 17,
    width: 55,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.43 21.565c10.565 6.086 10.613 16.002.097 22.137-10.467 6.087-27.538 6.136-38.054 0C.956 37.567.859 27.701 11.326 21.565c10.467-6.087 27.538-6.087 38.103 0Z",
    fill: "url(#paint1_linear_264_13411)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_264_13411)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_264_13411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.43 21.565c10.565 6.086 10.613 16.002.097 22.137-10.467 6.087-27.538 6.136-38.054 0C.956 37.567.859 27.701 11.326 21.565c10.467-6.087 27.538-6.087 38.103 0Z",
    fill: "url(#paint2_linear_264_13411)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_264_13411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.357,
    cy: 54.546,
    rx: 14.062,
    ry: 6.261,
    fill: "url(#paint3_linear_264_13411)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.353 25.198c0 .147 0 .294-.049.393 0 .098-.049.245-.049.343 0 .147-.049.246-.049.393a.912.912 0 0 1-.097.343c-.05.148-.05.246-.098.393-.05.098-.05.246-.098.344-.049.147-.098.245-.147.392-.049.099-.098.246-.146.344-.05.147-.098.294-.196.393-.05.098-.098.245-.147.343-.049.147-.147.295-.196.393a2.83 2.83 0 0 1-.195.344c-.098.147-.196.343-.294.49-.049.099-.146.197-.195.295-.098.196-.245.343-.392.54-.049.098-.097.147-.146.245-.196.295-.44.54-.685.835l-.196.196-.587.59-.293.294c-.147.098-.245.245-.392.343-.097.098-.244.197-.39.295-.148.098-.294.245-.441.343-.147.099-.245.197-.391.295-.147.098-.294.196-.44.343l-.44.295c-.148.098-.343.196-.49.294-.196.148-.391.246-.636.393-.391.245-.831.442-1.223.687-.097.05-.244.147-.39.197-.343.147-.637.343-.98.49-.097.05-.244.099-.342.148-.44.196-.88.392-1.32.54-.098.049-.147.049-.245.098-.391.147-.782.294-1.174.392-.146.05-.342.099-.489.148-.195.049-.44.147-.636.196-.195.05-.391.098-.538.147a3.59 3.59 0 0 0-.684.197l-.587.147c-.245.049-.44.098-.685.147l-.587.148c-.245.049-.49.098-.685.147-.196.049-.342.049-.538.098a16.24 16.24 0 0 1-1.516.245c-.098 0-.147 0-.245.05l-1.32.147c-.147 0-.343.049-.539.049-.293.049-.587.049-.88.049-.196 0-.342.049-.538.049-.294 0-.587.049-.93.049h-3.13c-.244 0-.538 0-.783-.05h-.538c-.293 0-.537-.048-.831-.048-.147 0-.342 0-.49-.05-.341-.048-.684-.048-1.026-.097-.098 0-.147 0-.245-.05-.44-.049-.88-.098-1.272-.147-.048 0-.146 0-.195-.049-.343-.049-.734-.098-1.076-.196-.147-.05-.294-.05-.44-.098-.294-.05-.539-.099-.832-.148-.147-.049-.294-.049-.44-.098-.294-.049-.587-.147-.88-.196-.148-.05-.343-.098-.49-.147-.293-.05-.538-.148-.831-.197l-.44-.147c-.44-.147-.832-.245-1.272-.393-.098-.049-.147-.049-.245-.049-.49-.147-.978-.343-1.418-.54-.196-.098-.392-.147-.587-.245-.147-.05-.294-.098-.44-.196-.196-.099-.44-.197-.636-.295-.147-.049-.294-.098-.392-.196-.244-.099-.44-.246-.684-.344-.098-.049-.245-.098-.343-.147-.342-.197-.636-.344-.978-.54C6.14 32.659 3.5 28.584 3.5 24.56v6.38c0 4.075 2.641 8.1 7.924 11.192.293.197.636.344.978.54.098.05.245.098.343.147.244.099.44.246.684.344.147.05.294.147.392.196.195.099.39.197.636.295.146.049.293.147.44.196.146.05.293.098.44.197.049 0 .098.049.147.049.489.196.929.343 1.418.54a.44.44 0 0 0 .245.049c.44.147.831.294 1.272.392.048 0 .146.05.195.05.098 0 .147.048.245.048.293.099.538.148.831.197.147.049.343.098.49.147.293.05.586.147.88.196.098.05.244.05.342.099h.098c.294.049.538.098.831.147.147.049.294.049.44.098.343.05.734.098 1.077.196.049 0 .146 0 .196.05.44.048.88.098 1.271.147.098 0 .196 0 .245.049.342.049.684.049 1.027.098.147 0 .293 0 .44.049.294 0 .538.05.832.05h.538c.244 0 .538 0 .782.048h3.131c.293 0 .587-.049.93-.049.195 0 .341-.049.537-.049.294 0 .587-.049.88-.049.098 0 .196 0 .294-.05.049 0 .147 0 .196-.048l1.32-.148c.098 0 .147 0 .245-.049a16.23 16.23 0 0 0 1.516-.245h.147c.147 0 .245-.05.391-.098.245-.05.49-.098.685-.147l.587-.148c.245-.049.44-.098.685-.147l.587-.147c.244-.05.44-.098.684-.197.196-.049.392-.098.539-.147.195-.049.44-.147.635-.196.098-.05.196-.05.294-.098.049 0 .147-.05.196-.05.39-.147.782-.245 1.173-.392.098-.05.147-.05.245-.098.44-.197.88-.344 1.32-.54.099-.05.245-.098.343-.147.343-.148.685-.295.978-.491.147-.05.245-.098.392-.197.44-.196.831-.441 1.222-.687.098-.049.245-.147.343-.196.098-.05.196-.147.293-.197.147-.098.343-.196.49-.294l.44-.294c.146-.099.293-.197.44-.344.147-.098.293-.196.391-.295.147-.098.294-.196.44-.343.147-.098.245-.197.392-.295.146-.098.244-.245.391-.343l.147-.148.147-.147.587-.589.195-.196c.245-.246.49-.54.685-.835l.049-.049c.049-.049.098-.147.147-.196.146-.196.244-.344.39-.54.05-.098.148-.196.197-.295.097-.147.195-.294.293-.49.049-.05.049-.099.098-.148.049-.049.049-.147.098-.196.049-.147.146-.245.195-.393.05-.098.098-.245.147-.343.049-.147.098-.295.196-.393 0-.049.049-.098.098-.196 0-.05.048-.098.048-.147.05-.148.098-.246.147-.393.05-.098.05-.246.098-.344.049-.147.049-.245.098-.392 0-.05.049-.148.049-.197v-.147c.049-.147.049-.245.049-.393 0-.098.049-.245.049-.343 0-.148 0-.295.048-.393V24.757c.147.146.147.294.147.44Z",
    fill: "url(#paint4_linear_264_13411)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_264_13411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 9,
    width: 55,
    height: 32
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.43 13.565c10.565 6.086 10.613 16.002.097 22.137-10.467 6.087-27.538 6.136-38.054 0C.956 29.567.859 19.701 11.326 13.565c10.467-6.087 27.538-6.087 38.103 0Z",
    fill: "url(#paint5_linear_264_13411)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_264_13411)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_264_13411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.43 13.565c10.565 6.086 10.613 16.002.097 22.137-10.467 6.087-27.538 6.136-38.054 0C.956 29.567.859 19.701 11.326 13.565c10.467-6.087 27.538-6.087 38.103 0Z",
    fill: "url(#paint6_linear_264_13411)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_264_13411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.357,
    cy: 46.546,
    rx: 14.062,
    ry: 6.261,
    fill: "url(#paint7_linear_264_13411)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.353 17.198c0 .147 0 .294-.049.393 0 .098-.049.245-.049.343 0 .147-.049.246-.049.393a.912.912 0 0 1-.097.343c-.05.148-.05.246-.098.393-.05.098-.05.246-.098.344-.049.147-.098.245-.147.392-.049.099-.098.246-.146.344-.05.147-.098.294-.196.393-.05.098-.098.245-.147.343-.049.147-.147.295-.196.393a2.83 2.83 0 0 1-.195.344c-.098.147-.196.343-.294.49-.049.099-.146.197-.195.295-.098.196-.245.343-.392.54-.049.098-.097.147-.146.245-.196.295-.44.54-.685.835l-.196.196-.587.59-.293.294c-.147.098-.245.245-.392.343-.097.098-.244.197-.39.295-.148.098-.294.245-.441.343-.147.098-.245.197-.391.295-.147.098-.294.196-.44.343l-.44.295c-.148.098-.343.196-.49.294-.196.148-.391.246-.636.393-.391.245-.831.442-1.223.687-.097.05-.244.148-.39.197-.343.147-.637.343-.98.49-.097.05-.244.099-.342.148-.44.196-.88.392-1.32.54-.098.049-.147.049-.245.098-.391.147-.782.294-1.174.393-.146.049-.342.098-.489.147-.195.049-.44.147-.636.196-.195.05-.391.098-.538.147a3.59 3.59 0 0 0-.684.197l-.587.147c-.245.049-.44.098-.685.147l-.587.148c-.245.049-.49.098-.685.147-.196.049-.342.049-.538.098a16.24 16.24 0 0 1-1.516.245.44.44 0 0 0-.245.05l-1.32.147c-.147 0-.343.049-.539.049-.293.049-.587.049-.88.049-.196 0-.342.049-.538.049-.294 0-.587.049-.93.049h-3.13c-.244 0-.538 0-.783-.05h-.538c-.293 0-.537-.048-.831-.048-.147 0-.342 0-.49-.05-.341-.048-.684-.048-1.026-.097-.098 0-.147 0-.245-.05-.44-.049-.88-.098-1.272-.147-.048 0-.146 0-.195-.049-.343-.049-.734-.098-1.076-.196-.147-.05-.294-.05-.44-.098-.294-.05-.539-.098-.832-.148-.147-.049-.294-.049-.44-.098-.294-.049-.587-.147-.88-.196-.148-.05-.343-.098-.49-.147-.293-.05-.538-.148-.831-.197l-.44-.147c-.44-.147-.832-.245-1.272-.393-.098-.049-.147-.049-.245-.049-.49-.147-.978-.343-1.418-.54-.196-.098-.392-.147-.587-.245a1.739 1.739 0 0 1-.44-.196c-.196-.099-.44-.197-.636-.295-.147-.049-.294-.098-.392-.196-.244-.099-.44-.246-.684-.344-.098-.049-.245-.098-.343-.147-.342-.196-.636-.344-.978-.54C6.14 24.659 3.5 20.584 3.5 16.56v6.38c0 4.075 2.641 8.1 7.924 11.192.293.197.636.344.978.54.098.05.245.098.343.147.244.099.44.246.684.344.147.05.294.147.392.196.195.099.39.197.636.295.146.049.293.147.44.196.146.05.293.098.44.197.049 0 .098.049.147.049.489.196.929.343 1.418.54a.44.44 0 0 0 .245.049c.44.147.831.294 1.272.392.048 0 .146.05.195.05.098 0 .147.048.245.048.293.099.538.148.831.197.147.049.343.098.49.147.293.05.586.147.88.196.098.05.244.05.342.099h.098c.294.049.538.098.831.147.147.049.294.049.44.098.343.05.734.098 1.077.196.049 0 .146 0 .196.05.44.048.88.098 1.271.147.098 0 .196 0 .245.049.342.049.684.049 1.027.098.147 0 .293 0 .44.049.294 0 .538.05.832.05h.538c.244 0 .538 0 .782.048h3.131c.293 0 .587-.049.93-.049.195 0 .341-.049.537-.049.294 0 .587-.049.88-.049.098 0 .196 0 .294-.05.049 0 .147 0 .196-.048l1.32-.148c.098 0 .147 0 .245-.049a16.23 16.23 0 0 0 1.516-.245h.147c.147 0 .245-.05.391-.098.245-.05.49-.098.685-.147l.587-.148c.245-.049.44-.098.685-.147l.587-.147c.244-.05.44-.098.684-.197.196-.049.392-.098.539-.147.195-.049.44-.147.635-.196.098-.05.196-.05.294-.098.049 0 .147-.05.196-.05.39-.147.782-.245 1.173-.392.098-.05.147-.05.245-.098.44-.197.88-.344 1.32-.54.099-.05.245-.098.343-.147.343-.148.685-.295.978-.491.147-.05.245-.098.392-.197.44-.196.831-.441 1.222-.687.098-.049.245-.147.343-.196.098-.05.196-.147.293-.197.147-.098.343-.196.49-.294l.44-.294c.146-.099.293-.197.44-.344.147-.098.293-.196.391-.295.147-.098.294-.196.44-.343.147-.098.245-.196.392-.295.146-.098.244-.245.391-.343l.147-.147.147-.148c.195-.196.39-.393.587-.589l.195-.196c.245-.246.49-.54.685-.835l.049-.049c.049-.049.098-.147.147-.196.146-.196.244-.344.39-.54.05-.098.148-.196.197-.294.097-.148.195-.295.293-.491.049-.05.049-.098.098-.148.049-.049.049-.147.098-.196.049-.147.146-.245.195-.393.05-.098.098-.245.147-.343.049-.147.098-.295.196-.393 0-.049.049-.098.098-.196 0-.05.048-.098.048-.147.05-.148.098-.246.147-.393.05-.098.05-.246.098-.344.049-.147.049-.245.098-.392 0-.05.049-.148.049-.197v-.147c.049-.147.049-.245.049-.393 0-.098.049-.245.049-.343 0-.148 0-.295.048-.393V16.757c.147.146.147.294.147.44Z",
    fill: "url(#paint8_linear_264_13411)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_264_13411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 55,
    height: 32
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.43 5.565c10.565 6.086 10.613 16.002.097 22.137-10.467 6.087-27.538 6.136-38.054 0C.956 21.567.859 11.7 11.326 5.565c10.467-6.087 27.538-6.087 38.103 0Z",
    fill: "url(#paint9_linear_264_13411)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_264_13411)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_264_13411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.43 5.565c10.565 6.086 10.613 16.002.097 22.137-10.467 6.087-27.538 6.136-38.054 0C.956 21.567.859 11.7 11.326 5.565c10.467-6.087 27.538-6.087 38.103 0Z",
    fill: "url(#paint10_linear_264_13411)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_264_13411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.01,
    cy: 39.097,
    rx: 11.234,
    ry: 10.463,
    fill: "#EDA54D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.304 5.782c5.237 3.016 7.812 6.948 7.83 10.834.017 3.886-2.52 7.83-7.733 10.87-5.186 3.016-12.025 4.543-18.883 4.55-6.858.006-13.709-1.51-18.92-4.55-5.212-3.041-7.788-6.973-7.817-10.854-.03-3.88 2.484-7.81 7.671-10.851C16.638 2.765 23.477 1.25 30.341 1.25c6.864 0 13.728 1.515 18.963 4.532Z",
    stroke: "url(#paint11_linear_264_13411)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_264_13411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.357,
    cy: 38.546,
    rx: 14.062,
    ry: 6.261,
    fill: "url(#paint12_linear_264_13411)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47,
    r: 12,
    fill: "url(#paint13_linear_264_13411)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.21 42.467c.43-.151.914-.282 1.323-.378.409-.097 3.387-.416 3.387-.416l-.64-.614s-2.485-.995-3.112-.98c-.995.001-1.925.531-3.05 1.046-1.071.535-2.015.863-2.67 1.616-.424.465-1.313 3.004-1.313 3.004l.06.834 2.592-2.274c.362-.302.757-.528 1.153-.754l4.312 9.546 2.325-1.064-4.366-9.566Z",
    fill: "#171717"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5 51c2.94-.615 3.45-1.115 4.077-4 .627 2.885 1.176 3.385 4.076 4-2.94.615-3.45 1.115-4.076 4-.627-2.885-1.176-3.385-4.077-4Z",
    fill: "#171717"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_13411",
    x1: 54.937,
    y1: 36.742,
    x2: 5.594,
    y2: 43.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_13411",
    x1: 30.457,
    y1: 17,
    x2: 30.457,
    y2: 48.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_264_13411",
    x1: 30.457,
    y1: 17,
    x2: 30.457,
    y2: 48.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_264_13411",
    x1: 29.619,
    y1: 46.23,
    x2: 13.384,
    y2: 48.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA54D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96EFF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_264_13411",
    x1: 54.937,
    y1: 28.742,
    x2: 5.594,
    y2: 35.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_264_13411",
    x1: 30.457,
    y1: 9,
    x2: 30.457,
    y2: 40.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_264_13411",
    x1: 30.457,
    y1: 9,
    x2: 30.457,
    y2: 40.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_264_13411",
    x1: 29.619,
    y1: 38.23,
    x2: 13.384,
    y2: 40.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA54D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96EFF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_264_13411",
    x1: 54.937,
    y1: 20.742,
    x2: 5.594,
    y2: 27.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_264_13411",
    x1: 30.457,
    y1: 1,
    x2: 30.457,
    y2: 32.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_264_13411",
    x1: 30.457,
    y1: 1,
    x2: 30.457,
    y2: 32.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_264_13411",
    x1: 30.457,
    y1: 1,
    x2: 30.457,
    y2: 15.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_264_13411",
    x1: 29.619,
    y1: 30.23,
    x2: 13.384,
    y2: 32.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA54D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96EFF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_264_13411",
    x1: 47.5,
    y1: 35,
    x2: 47.5,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A07041"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_264_13411",
    x: -0.198,
    y: 13.272,
    width: 61.31,
    height: 38.742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 1.864
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_264_13411"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_264_13411",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_264_13411",
    x: -10.861,
    y: 32.13,
    width: 60.435,
    height: 44.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.078,
    result: "effect1_foregroundBlur_264_13411"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_264_13411",
    x: -0.198,
    y: 5.272,
    width: 61.31,
    height: 38.742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 1.864
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_264_13411"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_264_13411",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_264_13411",
    x: -10.861,
    y: 24.13,
    width: 60.435,
    height: 44.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.078,
    result: "effect1_foregroundBlur_264_13411"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_264_13411",
    x: -0.198,
    y: -2.728,
    width: 61.31,
    height: 38.742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 1.864
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_264_13411"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_264_13411",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_264_13411",
    x: 3.776,
    y: 2.634,
    width: 74.468,
    height: 72.927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_264_13411"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_264_13411",
    x: -10.861,
    y: 16.13,
    width: 60.435,
    height: 44.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.078,
    result: "effect1_foregroundBlur_264_13411"
  })))));
};
export default SvgStakeNEarn;